var React = require('react');

function IconPromotions (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.6665 9.99998C16.6665 9.08331 17.4165 8.33331 18.3332 8.33331V4.99998C18.3332 4.08331 17.5832 3.33331 16.6665 3.33331H3.33317C2.4165 3.33331 1.67484 4.08331 1.67484 4.99998V8.33331C2.5915 8.33331 3.33317 9.08331 3.33317 9.99998C3.33317 10.9166 2.5915 11.6666 1.6665 11.6666V15C1.6665 15.9166 2.4165 16.6666 3.33317 16.6666H16.6665C17.5832 16.6666 18.3332 15.9166 18.3332 15V11.6666C17.4165 11.6666 16.6665 10.9166 16.6665 9.99998V9.99998ZM12.9832 14L9.99984 12.0833L7.0165 14L7.9165 10.5666L5.17484 8.32498L8.70817 8.11665L9.99984 4.83331L11.2832 8.12498L14.8165 8.33331L12.0748 10.575L12.9832 14V14Z","fill":"white"}));
}

IconPromotions.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconPromotions;

IconPromotions.default = IconPromotions;
